// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Responsive dialog rules and mobile-affecting overrides live separately from the base modal layout. */

#profile-modal .modal:has(.profile-edit-dialog__social-account-select[popup-open]) #modal-desc,
#profile-modal .modal:has(#modal-desc > .profile__edit-form solid-ui-combobox:focus-within) #modal-desc {
  padding-bottom: calc(var(--profile-modal-panel-inline-padding) + 1.875rem);
}

@media (max-width: 576px) {
  #profile-modal {
    --profile-modal-panel-max-height: calc(100dvh - 4 * var(--spacing-sm));
    padding-top: env(safe-area-inset-top);
    padding-right: 0;
    padding-bottom: max(var(--spacing-sm), env(safe-area-inset-bottom));
    padding-left: 0;
    place-items: center;
  }

  #profile-modal .modal {
    width: var(--profile-modal-panel-width);
    max-width: var(--profile-modal-panel-max-width);
    min-width: 0;
    padding: 0;
    border-radius: var(--border-radius-base);
    overscroll-behavior: contain;
    justify-self: center;
    align-self: center;
    margin: 0;
  }

  #profile-modal .modal .modal-header {
    gap: var(--spacing-lg, 1.5625rem);
    padding: var(--spacing-sm, 0.938rem);
  }

  #profile-modal .modal #modal-title {
    font-size: var(--font-size-lg, 1.125rem);
    line-height: var(--line-height-tight, 1.4);
  }

  #profile-modal .modal #modal-desc {
    padding: var(--spacing-sm, 0.938rem) var(--spacing-sm, 0.938rem) var(--spacing-lg, 1.5625rem);
  }

  #profile-modal .modal #modal-desc:has(> .profile__edit-form--projects) {
    padding: var(--spacing-sm, 0.938rem) var(--spacing-sm, 0.938rem) var(--spacing-lg, 1.5625rem);
  }

  #profile-modal #modal-desc > .profile__edit-form--bio {
    display: flex;
    flex-direction: column;
    gap: var(--spacing-md, 1.25rem);
  }

  #profile-modal #modal-buttons {
    flex-direction: row;
    align-items: center;
    justify-content: flex-end;
    gap: var(--profile-modal-button-gap);
    padding: var(--profile-modal-compact-padding);
    width: 100%;
  }

  #profile-modal #modal-buttons > solid-ui-button {
    flex: 1 0 0;
    width: auto;
    min-width: 0;
    --button-font-size-md: var(--font-size-md, 1rem);
  }
}

html[data-layout='mobile'] #profile-modal {
  --profile-modal-panel-max-height: calc(100dvh - 4 * var(--spacing-sm));
  padding-top: env(safe-area-inset-top);
  padding-right: 0;
  padding-bottom: max(var(--spacing-sm), env(safe-area-inset-bottom));
  padding-left: 0;
  place-items: center;
}

html[data-layout='mobile'] #profile-modal .modal {
  width: var(--profile-modal-panel-width);
  height: auto;
  max-height: var(--profile-modal-panel-max-height);
  max-width: var(--profile-modal-panel-max-width);
  min-width: 0;
  padding: 0;
  border-radius: var(--border-radius-base);
  overscroll-behavior: contain;
  justify-self: center;
  align-self: center;
  margin: 0;
}

html[data-layout='mobile'] #profile-modal .modal .modal-header {
  gap: var(--spacing-lg, 1.5625rem);
  padding: var(--spacing-sm, 0.938rem);
}

html[data-layout='mobile'] #profile-modal .modal #modal-title {
  font-size: var(--font-size-lg, 1.125rem);
  line-height: var(--line-height-tight, 1.4);
}

html[data-layout='mobile'] #profile-modal .modal #modal-desc {
  padding: var(--spacing-sm, 0.938rem) var(--spacing-sm, 0.938rem) var(--spacing-lg, 1.5625rem);
}

html[data-layout='mobile'] #profile-modal .modal #modal-desc:has(> .profile__edit-form--projects) {
  padding: var(--spacing-sm, 0.938rem) var(--spacing-sm, 0.938rem) var(--spacing-lg, 1.5625rem);
}

html[data-layout='mobile'] #profile-modal #modal-desc > .profile__edit-form--bio {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-md, 1.25rem);
}

html[data-layout='mobile'] #profile-modal #modal-buttons {
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
  gap: var(--profile-modal-button-gap);
  padding: var(--profile-modal-compact-padding);
  width: 100%;
}

html[data-layout='mobile'] #profile-modal #modal-buttons > solid-ui-button {
  flex: 1 0 0;
  width: auto;
  min-width: 0;
  --button-font-size-md: var(--font-size-md, 1rem);
}

@container profile-pane (max-width: 576px) {
  #profile-modal {
    --profile-modal-panel-max-height: calc(100dvh - 4 * var(--spacing-sm));
    padding-top: env(safe-area-inset-top);
    padding-right: 0;
    padding-bottom: max(var(--spacing-sm), env(safe-area-inset-bottom));
    padding-left: 0;
    place-items: center;
  }

  #profile-modal .modal {
    width: var(--profile-modal-panel-width);
    max-width: var(--profile-modal-panel-max-width);
    min-width: 0;
    padding: 0;
    border-radius: var(--border-radius-base);
    overscroll-behavior: contain;
    justify-self: center;
    align-self: center;
    margin: 0;
  }

  #profile-modal .modal .modal-header {
    gap: var(--spacing-lg, 1.5625rem);
    padding: var(--spacing-sm, 0.938rem);
  }

  #profile-modal .modal #modal-title {
    font-size: var(--font-size-lg, 1.125rem);
    line-height: var(--line-height-tight, 1.4);
  }

  #profile-modal .modal #modal-desc {
    padding: var(--spacing-sm, 0.938rem) var(--spacing-sm, 0.938rem) var(--spacing-lg, 1.5625rem);
  }

  #profile-modal .modal #modal-desc:has(> .profile__edit-form--projects) {
    padding: var(--spacing-sm, 0.938rem) var(--spacing-sm, 0.938rem) var(--spacing-lg, 1.5625rem);
  }

  #profile-modal #modal-desc > .profile__edit-form--bio {
    display: flex;
    flex-direction: column;
    gap: var(--spacing-md, 1.25rem);
  }

  #profile-modal #modal-buttons {
    flex-direction: row;
    align-items: center;
    justify-content: flex-end;
    gap: var(--profile-modal-button-gap);
    padding: var(--profile-modal-compact-padding);
    width: 100%;
  }

  #profile-modal #modal-buttons > solid-ui-button {
    flex: 1 0 0;
    width: auto;
    min-width: 0;
    --button-font-size-md: var(--font-size-md, 1rem);
  }
}
`, "",{"version":3,"sources":["webpack://./node_modules/profile-pane/lib/ui/dialog.responsive.css"],"names":[],"mappings":"AAAA,uGAAuG;;AAEvG;;EAEE,0EAA0E;AAC5E;;AAEA;EACE;IACE,sEAAsE;IACtE,qCAAqC;IACrC,gBAAgB;IAChB,mEAAmE;IACnE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,uCAAuC;IACvC,+CAA+C;IAC/C,YAAY;IACZ,UAAU;IACV,wCAAwC;IACxC,4BAA4B;IAC5B,oBAAoB;IACpB,kBAAkB;IAClB,SAAS;EACX;;EAEA;IACE,iCAAiC;IACjC,oCAAoC;EACtC;;EAEA;IACE,wCAAwC;IACxC,0CAA0C;EAC5C;;EAEA;IACE,6FAA6F;EAC/F;;EAEA;IACE,6FAA6F;EAC/F;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,+BAA+B;EACjC;;EAEA;IACE,mBAAmB;IACnB,mBAAmB;IACnB,yBAAyB;IACzB,oCAAoC;IACpC,6CAA6C;IAC7C,WAAW;EACb;;EAEA;IACE,WAAW;IACX,WAAW;IACX,YAAY;IACZ,gDAAgD;EAClD;AACF;;AAEA;EACE,sEAAsE;EACtE,qCAAqC;EACrC,gBAAgB;EAChB,mEAAmE;EACnE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,uCAAuC;EACvC,YAAY;EACZ,iDAAiD;EACjD,+CAA+C;EAC/C,YAAY;EACZ,UAAU;EACV,wCAAwC;EACxC,4BAA4B;EAC5B,oBAAoB;EACpB,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,iCAAiC;EACjC,oCAAoC;AACtC;;AAEA;EACE,wCAAwC;EACxC,0CAA0C;AAC5C;;AAEA;EACE,6FAA6F;AAC/F;;AAEA;EACE,6FAA6F;AAC/F;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,+BAA+B;AACjC;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,oCAAoC;EACpC,6CAA6C;EAC7C,WAAW;AACb;;AAEA;EACE,WAAW;EACX,WAAW;EACX,YAAY;EACZ,gDAAgD;AAClD;;AAEA;EACE;IACE,sEAAsE;IACtE,qCAAqC;IACrC,gBAAgB;IAChB,mEAAmE;IACnE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,uCAAuC;IACvC,+CAA+C;IAC/C,YAAY;IACZ,UAAU;IACV,wCAAwC;IACxC,4BAA4B;IAC5B,oBAAoB;IACpB,kBAAkB;IAClB,SAAS;EACX;;EAEA;IACE,iCAAiC;IACjC,oCAAoC;EACtC;;EAEA;IACE,wCAAwC;IACxC,0CAA0C;EAC5C;;EAEA;IACE,6FAA6F;EAC/F;;EAEA;IACE,6FAA6F;EAC/F;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,+BAA+B;EACjC;;EAEA;IACE,mBAAmB;IACnB,mBAAmB;IACnB,yBAAyB;IACzB,oCAAoC;IACpC,6CAA6C;IAC7C,WAAW;EACb;;EAEA;IACE,WAAW;IACX,WAAW;IACX,YAAY;IACZ,gDAAgD;EAClD;AACF","sourcesContent":["/* Responsive dialog rules and mobile-affecting overrides live separately from the base modal layout. */\n\n#profile-modal .modal:has(.profile-edit-dialog__social-account-select[popup-open]) #modal-desc,\n#profile-modal .modal:has(#modal-desc > .profile__edit-form solid-ui-combobox:focus-within) #modal-desc {\n  padding-bottom: calc(var(--profile-modal-panel-inline-padding) + 1.875rem);\n}\n\n@media (max-width: 576px) {\n  #profile-modal {\n    --profile-modal-panel-max-height: calc(100dvh - 4 * var(--spacing-sm));\n    padding-top: env(safe-area-inset-top);\n    padding-right: 0;\n    padding-bottom: max(var(--spacing-sm), env(safe-area-inset-bottom));\n    padding-left: 0;\n    place-items: center;\n  }\n\n  #profile-modal .modal {\n    width: var(--profile-modal-panel-width);\n    max-width: var(--profile-modal-panel-max-width);\n    min-width: 0;\n    padding: 0;\n    border-radius: var(--border-radius-base);\n    overscroll-behavior: contain;\n    justify-self: center;\n    align-self: center;\n    margin: 0;\n  }\n\n  #profile-modal .modal .modal-header {\n    gap: var(--spacing-lg, 1.5625rem);\n    padding: var(--spacing-sm, 0.938rem);\n  }\n\n  #profile-modal .modal #modal-title {\n    font-size: var(--font-size-lg, 1.125rem);\n    line-height: var(--line-height-tight, 1.4);\n  }\n\n  #profile-modal .modal #modal-desc {\n    padding: var(--spacing-sm, 0.938rem) var(--spacing-sm, 0.938rem) var(--spacing-lg, 1.5625rem);\n  }\n\n  #profile-modal .modal #modal-desc:has(> .profile__edit-form--projects) {\n    padding: var(--spacing-sm, 0.938rem) var(--spacing-sm, 0.938rem) var(--spacing-lg, 1.5625rem);\n  }\n\n  #profile-modal #modal-desc > .profile__edit-form--bio {\n    display: flex;\n    flex-direction: column;\n    gap: var(--spacing-md, 1.25rem);\n  }\n\n  #profile-modal #modal-buttons {\n    flex-direction: row;\n    align-items: center;\n    justify-content: flex-end;\n    gap: var(--profile-modal-button-gap);\n    padding: var(--profile-modal-compact-padding);\n    width: 100%;\n  }\n\n  #profile-modal #modal-buttons > solid-ui-button {\n    flex: 1 0 0;\n    width: auto;\n    min-width: 0;\n    --button-font-size-md: var(--font-size-md, 1rem);\n  }\n}\n\nhtml[data-layout='mobile'] #profile-modal {\n  --profile-modal-panel-max-height: calc(100dvh - 4 * var(--spacing-sm));\n  padding-top: env(safe-area-inset-top);\n  padding-right: 0;\n  padding-bottom: max(var(--spacing-sm), env(safe-area-inset-bottom));\n  padding-left: 0;\n  place-items: center;\n}\n\nhtml[data-layout='mobile'] #profile-modal .modal {\n  width: var(--profile-modal-panel-width);\n  height: auto;\n  max-height: var(--profile-modal-panel-max-height);\n  max-width: var(--profile-modal-panel-max-width);\n  min-width: 0;\n  padding: 0;\n  border-radius: var(--border-radius-base);\n  overscroll-behavior: contain;\n  justify-self: center;\n  align-self: center;\n  margin: 0;\n}\n\nhtml[data-layout='mobile'] #profile-modal .modal .modal-header {\n  gap: var(--spacing-lg, 1.5625rem);\n  padding: var(--spacing-sm, 0.938rem);\n}\n\nhtml[data-layout='mobile'] #profile-modal .modal #modal-title {\n  font-size: var(--font-size-lg, 1.125rem);\n  line-height: var(--line-height-tight, 1.4);\n}\n\nhtml[data-layout='mobile'] #profile-modal .modal #modal-desc {\n  padding: var(--spacing-sm, 0.938rem) var(--spacing-sm, 0.938rem) var(--spacing-lg, 1.5625rem);\n}\n\nhtml[data-layout='mobile'] #profile-modal .modal #modal-desc:has(> .profile__edit-form--projects) {\n  padding: var(--spacing-sm, 0.938rem) var(--spacing-sm, 0.938rem) var(--spacing-lg, 1.5625rem);\n}\n\nhtml[data-layout='mobile'] #profile-modal #modal-desc > .profile__edit-form--bio {\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacing-md, 1.25rem);\n}\n\nhtml[data-layout='mobile'] #profile-modal #modal-buttons {\n  flex-direction: row;\n  align-items: center;\n  justify-content: flex-end;\n  gap: var(--profile-modal-button-gap);\n  padding: var(--profile-modal-compact-padding);\n  width: 100%;\n}\n\nhtml[data-layout='mobile'] #profile-modal #modal-buttons > solid-ui-button {\n  flex: 1 0 0;\n  width: auto;\n  min-width: 0;\n  --button-font-size-md: var(--font-size-md, 1rem);\n}\n\n@container profile-pane (max-width: 576px) {\n  #profile-modal {\n    --profile-modal-panel-max-height: calc(100dvh - 4 * var(--spacing-sm));\n    padding-top: env(safe-area-inset-top);\n    padding-right: 0;\n    padding-bottom: max(var(--spacing-sm), env(safe-area-inset-bottom));\n    padding-left: 0;\n    place-items: center;\n  }\n\n  #profile-modal .modal {\n    width: var(--profile-modal-panel-width);\n    max-width: var(--profile-modal-panel-max-width);\n    min-width: 0;\n    padding: 0;\n    border-radius: var(--border-radius-base);\n    overscroll-behavior: contain;\n    justify-self: center;\n    align-self: center;\n    margin: 0;\n  }\n\n  #profile-modal .modal .modal-header {\n    gap: var(--spacing-lg, 1.5625rem);\n    padding: var(--spacing-sm, 0.938rem);\n  }\n\n  #profile-modal .modal #modal-title {\n    font-size: var(--font-size-lg, 1.125rem);\n    line-height: var(--line-height-tight, 1.4);\n  }\n\n  #profile-modal .modal #modal-desc {\n    padding: var(--spacing-sm, 0.938rem) var(--spacing-sm, 0.938rem) var(--spacing-lg, 1.5625rem);\n  }\n\n  #profile-modal .modal #modal-desc:has(> .profile__edit-form--projects) {\n    padding: var(--spacing-sm, 0.938rem) var(--spacing-sm, 0.938rem) var(--spacing-lg, 1.5625rem);\n  }\n\n  #profile-modal #modal-desc > .profile__edit-form--bio {\n    display: flex;\n    flex-direction: column;\n    gap: var(--spacing-md, 1.25rem);\n  }\n\n  #profile-modal #modal-buttons {\n    flex-direction: row;\n    align-items: center;\n    justify-content: flex-end;\n    gap: var(--profile-modal-button-gap);\n    padding: var(--profile-modal-compact-padding);\n    width: 100%;\n  }\n\n  #profile-modal #modal-buttons > solid-ui-button {\n    flex: 1 0 0;\n    width: auto;\n    min-width: 0;\n    --button-font-size-md: var(--font-size-md, 1rem);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
